// extracted by mini-css-extract-plugin
export var cardContainer = "_q1-0";
export var cardHeader = "_q1-2";
export var collapsedState = "_q1-3";
export var dragHandle = "_q1-5";
export var dragHandleIcon = "_q1-6";
export var dragging = "_q1-1";
export var titleArea = "_q1-4";